//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from 'better-scroll'

  export default {
    data() {
      return {
        planBScroll:null,
        select:0,
      }
    },
    props: {
      list: {
        type: Array,
        default: ()=>{
          return []
        }
      },
      value:{
        type:Number,
        default:0
      }
    },
    watch: {
      list:{
        deep:true,
        handler(newValue, oldValue) {
          this.scroll();
        }
      },
      value(newValue, oldValue){
        this.select = newValue
      },
      select(newValue, oldValue){
        this.$emit("input",newValue)
      }
    },
    created(){
        this.select = this.value 
    },
    mounted () {
      this.scroll();
    },
    methods: {
      scroll(){
        this.$nextTick(() => {
          this.$refs.present.style.width = this.GetNum() + "rem"
            if (!this.planBScroll) {
                this.planBScroll = new BScroll(this.$refs.presentTab, {
                    startX: 0,
                    click: true,
                    scrollX: true,
                    scrollY: false,
                    eventPassthrough: 'vertical'
                });
            } else {
                this.planBScroll.refresh()
            }
        })
      },
      GetNum(){
        return this.list.length * 4.3
      },
      change(index){
        this.select = index;
        const schemeName = this.list[index].schemeName
        this.STATISTICS_CONFIG.insur_insurinfoinput_insurdetail_scheme_click({"ex":{scheme:schemeName }})
      },
      // 由于使用bscroll js根据class名称派发的事件无法生效（用于版本管理需求，后端会派发js事件切换页面后截图） 故增加此事件
      recall_present_detail_tab(index){
        this.change(index)
      }
    },
  }
